import React from 'react';

function Modal({ isOpen, onClose, title, children }) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-zinc-900/20 px-4 py-8 backdrop-blur-sm">
      <div className="relative w-full max-w-sm rounded-2xl border border-zinc-800/100 bg-zinc-900/80 p-4 shadow-2xl backdrop-blur-md sm:max-w-md sm:p-6">
        <button
          onClick={onClose}
          className="absolute top-3 right-3 cursor-pointer text-lg text-white transition-colors hover:text-white sm:top-4 sm:right-4 sm:text-xl"
        >
          ×
        </button>

        <h2 className="mb-4 text-center text-xl font-bold text-white sm:text-2xl">
          {title}
        </h2>

        {children}
      </div>
    </div>
  );
}

export default Modal;
